import {CompetitionBracketsPageRouteMetaDataModel} from "./competition-brackets-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionBracketsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.brackets,
      path: `brackets`,
      componentImport: () => import("../components/competition-brackets-page" /* webpackChunkName: "competition-brackets-page" */ ),
      metadataType: CompetitionBracketsPageRouteMetaDataModel
    });
  }
}
